import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const deleteBatch = createApiThunk<void, string>(
  "batches/deleteBatch",
  async (batchId, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.deleteBatch(batchId);
  },
);

export const resetDeleteBatch = createAction("batches/resetDeleteBatch");
